import React from 'react'

export default class EdadArterial extends React.Component {
  render () {
    // console.log('estas son las propiedad', this.props.propiedades)
    return (
      <div className='someText' contentEditable='true'>
        <div className='someText-body'>
          <strong className='blue'>Edad arterial: </strong> {this.props.propiedades.data.arterialAge.toFixed(2)} años.
          { (this.props.propiedades.arterialAgeResult === 'mala')
            ? ' Su edad arterial está muy alta y hay riesgos que corregir.'
            : (this.props.propiedades.arterialAgeResult === 'apropiada')
            ? ' Su edad arterial está en un rango apropiado.'
            : (this.props.propiedades.arterialAgeResult === 'excelente')
            ? ' Su edad arterial es excelente, mantenga esta buena salud cardiovascular.' : ''
          }
        </div>
      </div>
    )
  }
}

EdadArterial.propTypes = {
  propiedades: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/edadArterialText.js